// src/pages/CreateProposalQuestions.jsx
import React, { useEffect, useMemo, useState,useRef} from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../chat/api";
import { Header } from "../../components/Header/Header";
import SmartAnswer from "./SmartAnswer";
import { getFreshAccessToken } from "../chat/api";
const Tag = ({ children }) => (
  <span
    className="inline-flex items-center justify-center gap-[10px] 
               px-[20px] py-[6px] rounded-[16px] 
               text-[14px] font-medium font-[Outfit] 
               text-[#18101C]"
    style={{
      background: "var(--sec_shade, rgba(139, 85, 221, 0.16))",
      lineHeight: "normal",
    }}
  >
    {children}
  </span>
);


const SectionCard = ({ section, pdf_key, loadQuestions, openedSections, setOpenedSections }) => {
  const [posting, setPosting] = useState(false);
  const [progress, setProgress] = useState(null); 
  const wsRef = useRef(null);

 const connectWebSocket = async () => {
    try {
      const token = await getFreshAccessToken(); // fetch latest token

      const ws = new WebSocket(
        `wss://stagingbackend.docusensa.com/ws/upload-status/?token=${token}`
      );

      ws.onopen = () => {
        console.log("WS connected");
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data.pdf_key !== pdf_key) return; // only listen for this document
          if (data.metadata?.scope !== "section_responses") return; // only section responses

          if (data.type === "progress") {
            setProgress(data.progress);
          } else if (data.type === "completed") {
            setProgress(100);
            setTimeout(() => setProgress(null), 1500); // auto-hide
            loadQuestions();
          }
        } catch (err) {
          console.error("WS parse error", err);
        }
      };

      ws.onclose = () => {
        console.log("WS closed");
      };

      wsRef.current = ws;
    } catch (err) {
      console.error("Failed to connect WS", err);
    }
  };

   const handleGenerate = async () => {
    try {
      setPosting(true);
      await connectWebSocket();
      await api.post(
        `/api/v1/rfp/documents/${pdf_key}/sections/${section.section_id}/generate-responses/`
      );
      setOpenedSections((prevState) => ({
        ...prevState,
        [section.section_id]: true,
      }));
    } catch (e) {
      console.error("Generate section failed", e);
    } finally {
      setPosting(false);
    }
  };

  return (
    <div className="rounded-[12px] border border-[rgba(0,0,0,0.1)] bg-white">
      {/* Section Header */}
      <div
        className="flex items-center justify-between px-5 py-4 cursor-pointer"
        onClick={() =>
          setOpenedSections((prev) => ({
            ...prev,
            [section.section_id]: !prev[section.section_id],
          }))
        }
      >
        <div className="text-[16px] font-semibold text-[#18101C]">
          {section.section}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[13px] bg-[#F5F5F5] px-3 py-1 rounded-full">
            {section.questions.length} asks
          </span>
          <span>{openedSections[section.section_id] ? "▲" : "▶"}</span>
        </div>
      </div>

      {/* Section Body */}
      {openedSections[section.section_id] && (
        <div className="px-5 pb-4 flex flex-col gap-4">
          {section.questions.map((q, idx) => (
            <QuestionCard
              key={q.id}
              idx={idx}
              q={q}
              pdf_key={pdf_key}
              loadQuestions={loadQuestions}
            />
          ))}

          {/* Footer Generate */}
         <div className="flex justify-end mt-2 relative w-full">
  {progress !== null ? (
    <div className="flex flex-col gap-2 w-full max-w-[280px]">
      {/* Progress Bar Track */}
      <div className="w-full h-3 bg-gray-100 border border-gray-200 rounded-full overflow-hidden shadow-sm">
        {/* Progress Fill */}
        <div
          className="h-full transition-all duration-500 ease-in-out rounded-full"
          style={{
            width: `${progress}%`,
            background: "linear-gradient(90deg, #8B55DD, #BB42AE)",
            boxShadow: "0 0 6px rgba(139, 85, 221, 0.4)",
          }}
        />
      </div>

      {/* Label + % */}
      <div className="flex justify-between items-center text-sm">
        <span className="text-gray-600">Generating…</span>
        <span className="font-semibold text-[var(--Primary_400,#8B55DD)]">
          {progress}%
        </span>
      </div>
    </div>
  ) : (
    <button
      onClick={handleGenerate}
      disabled={posting}
      className={`px-5 py-2 rounded-[6px] text-[14px] font-medium
                 bg-[rgba(187,66,174,0.16)]
                 text-[var(--Primary_400,#A04A97)]
                 ${
                   posting
                     ? "opacity-50 cursor-wait"
                     : "hover:opacity-80"
                 }`}
    >
      {posting ? "Starting…" : "Generate Responses"}
    </button>
  )}
</div>

        </div>
      )}
    </div>
  );
};




const IconBtn = ({ icon, label, onClick }) => (
  <button
    onClick={onClick}
    className="inline-flex items-center gap-2 px-3 py-1.5 rounded-[8px] border border-[rgba(0,0,0,0.10)] text-[13px] text-[#3F3F46] hover:bg-[#FAF9F6]"
  >
    <img src={icon} className="w-4 h-4" alt="" />
    {label}
  </button>
);

// 3) Make QuestionCard read normalized/fallback values
const QuestionCard = ({ idx, q, pdf_key, loadQuestions }) => {
  const questionText = q?.question_text || q?.question || "—";
  const answerText =
    q?.answer ||
    q?.latest_response?.response_text ||
    q?.response ||
    q?.generated_answer ||
    q?.ai_answer ||
    "";

  const getResponseId = (q) => q?.latest_response?.id ?? q?.response_id ?? null;
  const responseId = getResponseId(q);

  const hasAnswer = !!answerText; // ✅ gate everything here

  const [showInstruct, setShowInstruct] = useState(false);
  const [instructionText, setInstructionText] = useState("");
  const [posting, setPosting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(answerText);
  const [saving, setSaving] = useState(false);

  // --- Mark Irrelevant ---
  const handleMarkIrrelevant = async () => {
    try {
      await api.delete(`/api/v1/rfp/documents/${pdf_key}/extract-questions/`, {
        data: { question_ids: [q.id] },
      });
      await loadQuestions();
    } catch (e) {
      console.error("Failed to mark irrelevant", e);
    }
  };

  // --- Save Edit ---
  const handleSaveEdit = async () => {
    if (!responseId) return;
    try {
      setSaving(true);
      await api.put(`/api/v1/rfp/responses/${responseId}/edit/`, {
        response_text: editValue.trim(),
      });
      await loadQuestions();
      setIsEditing(false);
    } catch (e) {
      console.error("Edit failed", e);
    } finally {
      setSaving(false);
    }
  };

  // --- Instruct ---
  const handleGenerate = async () => {
    if (!instructionText.trim() || !responseId) return;
    try {
      setPosting(true);
      await api.post(
        `/api/v1/rfp/responses/${responseId}/instruct/`,
        { instruction_text: instructionText.trim() }
      );
      await loadQuestions();
      setShowInstruct(false);
      setInstructionText("");
    } catch (e) {
      console.error("Instruct POST failed", e);
    } finally {
      setPosting(false);
    }
  };

  return (
    <div className="w-full rounded-[12px] bg-white pl-8 pt-3 pr-4 pb-3 border border-[rgba(0,0,0,0.10)] mb-3">
      <div className="flex items-center justify-between">
        {/* Left */}
        <span
          className="text-[16px] font-medium font-[Outfit]"
          style={{ color: "var(--Text-h1, #18101C)" }}
        >
          Requirement: {idx + 1}
        </span>

        {/* Right */}
        <div className="flex items-center gap-2">
          {!hasAnswer ? (
            // ❌ Mark Irrelevant
            <button
              onClick={handleMarkIrrelevant}
              className="inline-flex px-3 py-1.5 items-center rounded-[6px] text-[13px] font-medium text-red-500 hover:bg-red-50"
            >
              ❌ Mark Irrelevant
            </button>
          ) : isEditing ? (
            <>
               <button
  onClick={() => setIsEditing(false)}
  className="flex px-5 py-2 items-center justify-center gap-[6px]
             rounded-[6px] border border-[rgba(0,0,0,0.10)]
             bg-[var(--White,#F5F4F3)]"
>
  <span
    className="text-[14px] font-[Outfit]"
    style={{ color: "var(--Text-h1,#18101C)", fontWeight: 500 }}
  >
    Cancel
  </span>
</button>

<button
  onClick={handleSaveEdit}
  disabled={saving}
  className={`flex px-5 py-2 items-center justify-center gap-[6px]
              rounded-[6px] border border-[rgba(0,0,0,0.10)]
              bg-[var(--White,#F5F4F3)]
              ${saving ? "opacity-70 cursor-wait" : "hover:bg-[#EDEDED]"}`}
>
  <span
    className="text-[14px] font-[Outfit]"
    style={{ color: "var(--Text-h1,#18101C)", fontWeight: 500 }}
  >
    {saving ? "Saving…" : "Save"}
  </span>
</button>
            </>
          ) : (
            <>
              <button
                onClick={() => setShowInstruct((s) => !s)}
                className="inline-flex h-[34px] px-3 items-center gap-[6px]
                           rounded-[6px] border border-[rgba(0,0,0,0.10)]
                           text-[14px] font-medium font-[Outfit]"
                style={{ color: "var(--Primary_400, #A04A97)" }}
                disabled={!responseId}
              >
                <img src="/ai-instruct.svg" alt="" className="w-4 h-4" />
                <span>Ai Instruct</span>
              </button>
              <button
                onClick={() => {
                  setEditValue(answerText);
                  setIsEditing(true);
                }}
                className="inline-flex px-6 py-2 rounded-[6px]
                           text-[14px] font-medium font-[Outfit]
                           bg-[#F5F4F3] text-[#18101C]"
              >
                <img src="/edit-mini.svg" alt="" className="w-4 h-4" />
                <span>Edit</span>
              </button>
            </>
          )}
        </div>
      </div>

      {/* Question text */}
      <p className="mt-3 text-[14px] font-semibold">{questionText}</p>

      {/* Answer (only if exists) */}
      {hasAnswer && (
        <div className="mt-3">
          {isEditing ? (
            <textarea
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              className="w-full h-[200px] rounded-[9px] border px-3 py-3 resize-none focus:outline-none"
            />
          ) : (
            <SmartAnswer value={answerText} showOnlyTables />
          )}
        </div>
      )}

      {/* Instruct Section */}
      {showInstruct && hasAnswer && (
        <div className="mt-4">
          <div className="text-[14px] font-semibold mb-2">
            Instruct AI for this question
          </div>
          <textarea
            value={instructionText}
            onChange={(e) => setInstructionText(e.target.value)}
           placeholder="Type anything here to improve Your AI Generated Answer With your Prompts"
  className="w-[100%] rounded-[9px] border border-[rgba(0,0,0,0.10)]
             px-3 py-3 h-[74px] resize-none focus:outline-none
             text-[14px] font-[Outfit] font-medium leading-normal
             text-[rgba(82,82,91,0.66)]
             placeholder-[color:rgba(82,82,91,0.66)]
             placeholder:font-[Outfit] placeholder:text-[14px]
             placeholder:font-medium placeholder:leading-normal"
          />
          <div className="mt-3 flex justify-end gap-2">
            <button
              onClick={() => setShowInstruct(false)}
               className="flex h-[34px] px-[12px] items-center justify-center gap-[6px]
                         rounded-[6px] border border-[rgba(0,0,0,0.10)] bg-white"
            >
              <span
                className="text-[14px] font-[Outfit]"
                style={{ color: "var(--Text-h1, #18101C)", fontWeight: 500 }}
              >
                Cancel
              </span>
            </button>
             
            <button
              onClick={handleGenerate}
              disabled={!instructionText.trim() || !responseId || posting}
              className={`flex h-[34px] px-[12px] items-center justify-center gap-[6px]
              rounded-[6px] border border-[rgba(0,0,0,0.10)]
              bg-[#F4E1F2] ${
                posting ? "cursor-wait opacity-50" : "hover:opacity-80"
              }`}
            >
  <span className="text-[14px] font-[Outfit] font-medium text-[var(--Primary_400,#A04A97)]"                style={{ color: "var(--Primary_400, #A04A97)", fontWeight: 500 }}
>
    {posting ? "Generating…" : "Generate"}
  </span>            </button>
          </div>
        </div>
      )}
    </div>
  );
};




/** BEFORE responses: one simple square box listing all questions */
/** BEFORE responses: one simple square box listing all questions */
const QuestionsListPanel = ({ questions, onGenerate, generating }) => {
  return (
    <div className="w-full rounded-[12px] bg-white p-5 border border-[rgba(0,0,0,0.10)]">
      <h3 className="text-[#18101C] text-[16px] font-semibold mb-3">
          Requirements extracted from your RFP

      </h3>

      <div
        className="rounded-[10px] border border-[rgba(0,0,0,0.08)] bg-[#FAFAFA] 
                   p-4 max-h-[500px] overflow-y-auto flex flex-col gap-3 filter-scrollbar"
      >
        {questions.length === 0 ? (
          <p className="text-[#6A6A6A] text-[14px]">No Requirements found.</p>
        ) : (
          questions.map((q, i) => (
            <div
              key={q.id || i}
              className="p-3 bg-white rounded-[8px] border border-[rgba(0,0,0,0.08)] 
                         transition-colors duration-200 hover:bg-[#F4EBFF]/60"
            >
              <p className="text-[#18101C] text-[14px] leading-6 font-medium">
                {i + 1}. {q?.question_text || q?.question || "—"}
              </p>
              <p className="text-[#6A6A6A] text-[12px] mt-1">
                Awaiting response generation…
              </p>
            </div>
          ))
        )}
      </div>

      {/* Button at bottom of box */}
      <div className="flex justify-end mt-4">
        <button
          disabled={generating || questions.length === 0}
          onClick={onGenerate}
          className={`px-5 py-2 rounded-[8px] text-white font-semibold text-[14px]
                     ${generating || questions.length === 0
                       ? "bg-[#C7A8F3] cursor-not-allowed"
                       : "bg-[#8B55DD] hover:bg-[#7A4CC4]"}`}
        >
          {generating ? "Generating…" : "Generate Responses"}
        </button>
      </div>
    </div>
  );
};




export default function CreateProposalQuestions({ isMenuOpen }) {
  const { pdf_key } = useParams();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
const [sections, setSections] = useState([]);
const [openedSections, setOpenedSections] = useState({});


  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewQ, setPreviewQ] = useState(null);
  const [generating, setGenerating] = useState(false);
// Create Proposal states
const [creatingProposal, setCreatingProposal] = useState(false);
const [proposalPopup, setProposalPopup] = useState({ open: false, msg: "" });

const openProposalPopup = (msg = "Proposal created!") => {
  setProposalPopup({ open: true, msg });
  setTimeout(() => setProposalPopup({ open: false, msg: "" }), 4500);
};
const handleCreateProposal = async () => {
  try {
    setCreatingProposal(true);
    await api.post(
      `/api/v1/rfp/documents/${pdf_key}/generate-proposal/`
    );
    openProposalPopup("Proposal created!");
  } catch (e) {
    console.error("Create proposal failed", e);
    openProposalPopup("Failed to create proposal");
  } finally {
    setCreatingProposal(false);
  }
};
  // GET /questions/
// 1) Normalize after GET /questions/
 const loadQuestions = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get(`/api/v1/rfp/documents/${pdf_key}/questions/`);
      const grouped = res?.data?.grouped_by_section || [];
      const normalized = grouped.map((section) => ({
        ...section,
        questions: section.questions.map((q) => ({
          ...q,
          answer:
            q?.answer ||
            q?.response ||
            q?.generated_answer ||
            q?.ai_answer ||
            q?.latest_response?.response_text ||
            "",
        })),
      }));
      setSections(normalized);
    } catch (e) {
      console.error(e);
      setError("Failed to load questions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadQuestions();
  }, [pdf_key]);

  const generateSection = async (sectionId) => {
  try {
    await api.post(
      `/api/v1/rfp/documents/${pdf_key}/sections/${sectionId}/generate-responses/`
    );
    await loadQuestions(); // refresh just updates section responses
  } catch (e) {
    console.error("Failed to generate section responses", e);
  }
};


  const onOpenPreview = (q) => {
    setPreviewQ(q);
    setPreviewOpen(true);
  };
  const onClosePreview = () => {
    setPreviewOpen(false);
    setPreviewQ(null);
  };

  // Detect if any question already has an answer (various possible fields)
// 2) Broaden the AFTER/BEFORE detection
const hasAnyResponse = useMemo(
  () =>
    questions.some(
      (q) =>
        !!q?.answer ||
        !!q?.latest_response?.response_text ||
        q?.is_answered === true ||
        (typeof q?.response_count === "number" && q.response_count > 0)
    ),
  [questions]
);


  // POST /generate-all-responses/
  const generateAll = async () => {
    setGenerating(true);
    try {
      await api.post(`/api/v1/rfp/documents/${pdf_key}/generate-all-responses/`);
      await loadQuestions(); // refresh to show answers if API returns them
    } catch (e) {
      console.error("Failed to generate responses", e);
    } finally {
      setGenerating(false);
    }
  };

  return (
    
<div
  className="full_Container custom-scrollbar"
  style={{
    backgroundColor: "var(--Background-main, #FEF9F7)",
    minHeight: "90vh",
  }}
>
  <div className="header-container">
    <Header
      icon="/arrow-back.svg"
      name="Go to Create Proposal"
    />
  </div>

  <div
    className={`${isModalOpen ? "blur-background" : ""}`}
    style={{ marginLeft: isMenuOpen ? "190px" : "100px" }}
  >
    {/* Body */}
    <div className="px-6">
      {loading ? (
        <div className="mt-6 text-[#6A6A6A]">Loading…</div>
      ) : error ? (
        <div className="mt-6 text-red-500">{error}</div>
      ) : sections.length === 0 ? (
        <div className="flex items-center justify-center min-h-[60vh] mb-2">
          <div className="relative w-[360px] rounded-2xl bg-white p-8 text-center animate-fadeIn overflow-hidden">
            <div className="absolute inset-0 rounded-2xl p-[3px] border-runner z-0 pointer-events-none">
              <div className="w-full h-full rounded-2xl bg-white"></div>
            </div>
            <div className="relative z-10 flex flex-col items-center justify-center">
              <div className="mb-3 animate-bounce">
                <img
                  src="/docusensas-logo.svg"
                  alt="DocuSensa Logo"
                  className="w-[60px] h-[60px]"
                  style={{ filter: "brightness(0) saturate(100%)" }}
                />
              </div>
              <h3 className="text-[18px] font-semibold text-[#18101C]">
                Oops!
              </h3>
              <p className="mt-2 text-[14px] font-medium text-[#52525B]">
                No sections or questions were created for this document.<br />
                It may not be a valid RFP.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-4 flex flex-col gap-6">
              {sections.map((section) => (
                <SectionCard
                  key={section.section_id}
                  section={section}
                  pdf_key={pdf_key}
                  loadQuestions={loadQuestions}
                  openedSections={openedSections}  // Pass openedSections state
                  setOpenedSections={setOpenedSections}  // Pass setOpenedSections function
                />
              ))}
            </div>

      )}
    </div>
  </div>

  {/* Preview Popup (unchanged) */}
  {previewOpen && (
    <div
      className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-[1.5px] flex items-center justify-center"
      onClick={onClosePreview}
    >
      <div
        className="bg-white rounded-[12px] w-[640px] max-w-[92vw] p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between">
          <h3 className="text-[16px] font-semibold text-[#18101C]">
            Question Preview
          </h3>
          <button className="text-[20px]" onClick={onClosePreview}>
            ×
          </button>
        </div>
        <div className="mt-3 text-[14px] text-[#18101C] leading-6">
          {previewQ?.question_text || previewQ?.question || "—"}
        </div>
        <div className="mt-5 flex justify-end">
          <button
            onClick={onClosePreview}
            className="px-4 py-2 rounded-md border border-[rgba(0,0,0,0.10)] text-[14px] hover:bg-[#F5F5F5]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )}

  {/* Proposal Popup (unchanged) */}
  {proposalPopup.open && (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-[12px] w-[360px] px-6 py-5 text-center font-[Outfit]">
        <div className="text-[16px] font-semibold text-[#18101C]">
          {proposalPopup.msg || "Proposal created!"}
        </div>
        <div className="mt-2 text-[14px] text-[#52525B]">
          Your proposal has been created successfully.
          <br />
          You can review it in the{" "}
          <span className="font-semibold text-[var(--Primary_400,#A04A97)]">
            Response Writer
          </span>{" "}
          table view.
        </div>
        <div className="mt-5">
          <button
            onClick={() => setProposalPopup({ open: false, msg: "" })}
            className="px-6 py-1 rounded-[6px] border border-[rgba(160,74,151,0.20)]
                       bg-[rgba(187,66,174,0.16)]
                       text-[14px] font-semibold text-[var(--Primary_400,#A04A97)]
                       hover:opacity-80 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )}
</div>

  );
}
